import { getStatusLight } from "./statusLights";
import { getStatusLightAppearance } from "./statusLightAppearance";
import { createStatusLightCircle } from "./statusLightCircle";

export function formatStatusLight(cell, project) {
    const light = getStatusLight(cell.getData(), project);
    const appearance = getStatusLightAppearance(light, project);
    const element = cell.getElement();
    if (element.style.display === "none") return "";
    element.style.backgroundColor = "";
    element.style.backgroundImage = "";
    element.style.color = "";
    element.classList.remove("status-light-circle-cell");
    element.title = `${light.colorName}燈：${light.label}`;
    element.setAttribute("aria-label", element.title);

    if (appearance.type === 'circle') {
        element.classList.add("status-light-circle-cell");
        return createStatusLightCircle(light, appearance.withText);
    }

    if (appearance.type === 'image') {
        element.style.backgroundImage = `url(${appearance.src})`;
        element.style.backgroundRepeat = "no-repeat";
        element.style.backgroundPosition = "center";
        element.style.backgroundSize = "auto";
        return "";
    }
    if (appearance.type === 'emoji' || appearance.type === 'text') return appearance.text;
    element.style.backgroundColor = appearance.background;
    element.style.color = appearance.foreground;
    return appearance.text;
}
